<template>
    <div>
        <modal-x :show="isSelectingImage" @onclose="isSelectingImage=false">
            <image-list v-if="isSelectingImage" :user-id="shopInfo.shopUserId" @onselect="onImgSelect"></image-list>
        </modal-x>
        <modal-x :show="isEditValidateJson" @onclose="isEditValidateJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-validator v-if="isEditValidateJson" :shop-user-id="shopInfo.shopUserId" @onsave="onJsonDataValidatorReturn" :init-data="initJsonData"></json-data-validator>
        </modal-x>
        <modal-x :show="isEditJson" @onclose="isEditJson=false" :content-style="{maxWidth:'800px'}">
            <json-data v-if="isEditJson" :shop-user-id="shopInfo.shopUserId" @onsave="onJsonReturn" :init-data="initJsonData"></json-data>
        </modal-x>
        <modal-x :show="isEditSlideJson" @onclose="isEditSlideJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-slide v-if="isEditSlideJson" :shop-user-id="shopInfo.shopUserId" @onsave="onSlideJsonReturn" :init-data="initJsonData"></json-data-slide>
        </modal-x>
        <modal-x :show="isEditLayoutJson" @onclose="isEditLayoutJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-layout v-if="isEditLayoutJson" :shop-user-id="shopInfo.shopUserId" @onsave="onLayoutJsonReturn" :init-data="initJsonData"></json-data-layout>
        </modal-x>
        <modal-x :show="isEditLawsJson" @onclose="isEditLawsJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-laws v-if="isEditLawsJson" :shop-user-id="shopInfo.shopUserId" @onsave="onLawsJsonReturn" :init-data="initJsonData"></json-data-laws>
        </modal-x>
        <modal-x :show="isEditLandingJson" @onclose="isEditLandingJson=false" :content-style="{maxWidth:'800px'}">
            <json-data-landing v-if="isEditLandingJson" :shop-user-id="shopInfo.shopUserId" @onsave="onLandingJsonReturn" :init-data="initJsonData"></json-data-landing>
        </modal-x>
        <div v-if="labelType==='_landing'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-4">
                    <div style="word-wrap:break-word;">
                        {{newLabel.text0}}
                    </div>
                </div>
                <div class="col-xs-12 col-md-8">
                    Laws Title:
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="newLabel.label" />
                        <input type="button" class="btn btn-default" @click="isEditLandingJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}" value="Edit Json" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="labelType==='_laws'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-4">
                    <div style="word-wrap:break-word;">
                        {{newLabel.text0}}
                    </div>
                </div>
                <div class="col-xs-12 col-md-8">
                    Laws Title:
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="newLabel.label" />
                        <input type="button" class="btn btn-default" @click="isEditLawsJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}" value="Edit Json" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="labelType==='_layout'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-4">
                    <div style="word-wrap:break-word;">
                        {{newLabel.text0}}
                    </div>
                </div>
                <div class="col-xs-12 col-md-8">
                    Theme Id:
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="newLabel.label" />
                        <input type="button" class="btn btn-default" @click="isEditLayoutJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}" value="Edit Json" />
                    </div>

                </div>
            </div>
        </div>
        <div v-if="labelType==='_pagedinfos'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-4">
                    <json-render :json-string="newLabel.text0" title-field="title"></json-render>
                </div>
                <div class="col-xs-12 col-md-8">
                    Target Page
                    <select v-model="newLabel.label" class="form-control">
                        <option value="">Please Select</option>
                        <option value="mobileIndex">Mobile Index Page</option>
                        <!-- <option value="indexTop">Index Page Top</option> --><!--disable it as does not support scroll top restoration on nav back-->
                        <option value="index">Index Page</option>
                        <option value="listing">Listing Page</option>
                        <option value="product">Product Page</option>
                        <option value="article">Article Page</option>
                    </select>
                    <input type="button" class="btn btn-default" @click="isEditJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}" value="Edit Json" />
                </div>
            </div>
        </div>

        <div v-if="labelType==='_validator'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-4">
                    <json-render :json-string="newLabel.text0" title-field="title"></json-render>
                </div>
                <div class="col-xs-12 col-md-8">
                    Target Data
                    <select v-model="newLabel.label" class="form-control">
                        <option value="">Please Select</option>
                        <option value="product">Product</option>
                        <option value="article">Article</option>
                    </select>
                    <input type="button" class="btn btn-default" @click="isEditValidateJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}" value="Edit Json" />
                </div>
            </div>
        </div>

        <div v-if="labelType==='_banner' || labelType==='_promo'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-4" style="text-align:center;">
                    <img v-if="newLabel.frnImgPath!==null" style="width:100%;max-width:100px;" :src="newLabel.frnImgPath" />
                    <span v-else class="glyphicon glyphicon-info-sign" style="font-size:30px;"></span>
                </div>
                <div class="col-xs-12 col-md-8">
                    Banner Image:
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="newLabel.label" />
                        <span class="input-group-btn">
                            <button class="btn btn-default" type="button" @click="selectImg(setNewLabelImg)">Select Image</button>
                        </span>
                    </div>
                    Banner link
                    <input class="form-control" type="text" v-model="newLabel.text1" />
                    Banner Message
                    <!--<input class="form-control" type="text" v-model="newLabel.text1" />-->
                    <input type="button" class="btn btn-default" @click="isEditSlideJson=true;initJsonData=JSON.parse(newLabel.text0); jsonHandler=(ret)=>{ newLabel.text0= JSON.stringify(ret);}" value="Edit Json" />
                    <div style="word-wrap:break-word;">
                        {{newLabel.text0}}
                    </div>
                </div>
            </div>
        </div>

        <div v-if="labelType==='_address'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-4" style="text-align:center;">
                    <img v-if="newLabel.frnImgPath!==null" style="width:100%;max-width:100px;" :src="newLabel.frnImgPath" />
                    <span v-else class="glyphicon glyphicon-info-sign" style="font-size:30px;"></span>
                </div>
                <div class="col-xs-12 col-md-8">
                    Address line 1
                    <input class="form-control" type="text" v-model="newLabel.label" />
                    Address line 2
                    <input class="form-control" type="text" v-model="newLabel.text0" />
                    Address line 3
                    <input class="form-control" type="text" v-model="newLabel.text1" />
                </div>

            </div>
        </div>

        <div v-if="labelType==='_news'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    Type
                    <!--<input class="form-control" type="text" v-model="newLabel.label" />-->
                    <select v-model="newLabel.label" class="form-control">
                        <option value="">Please Select</option>
                        <option value="0">Index Page Msg</option>
                        <option value="1">Item Page Msg</option>
                    </select>
                    Title
                    <input class="form-control" type="text" v-model="newLabel.text0" />
                    Content
                    <textarea class="form-control" type="text" v-model="newLabel.text1" />
                </div>
            </div>
        </div>

        <div v-if="labelType==='_whatsapp'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    Whatsapp
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="newLabel.label" />
                    </div>
                </div>

            </div>
        </div>

        <div v-if="labelType==='_wechat'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    WeChat
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="newLabel.label" />
                    </div>
                </div>

            </div>
        </div>

        <div v-if="labelType==='_email'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    Email
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="newLabel.label" />
                    </div>
                </div>

            </div>
        </div>

        <div v-if="labelType==='_phone'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    Phone
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="newLabel.label" />
                    </div>
                </div>

            </div>
        </div>

        <div v-if="labelType==='_lang'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    Language[chinese/english]
                    <!-- <input class="form-control" type="text" v-model="newLabel.label" /> -->
                    <select v-model="newLabel.label" class="form-control">
                        <option value="">Please Select</option>
                        <option value="english">English</option>
                        <option value="chinese">Chinese</option>
                    </select>
                </div>
            </div>
        </div>

        <div v-if="labelType === '_lang_backend'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    Backend Language[chinese/english]
                    <!-- <input class="form-control" type="text" v-model="newLabel.label" /> -->
                    <select v-model="newLabel.label" class="form-control">
                        <option value="">Please Select</option>
                        <option value="english">English</option>
                        <option value="chinese">Chinese</option>
                    </select>
                </div>
            </div>
        </div>

        <div v-if="labelType==='_permit'">
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-4" style="text-align:center;">

                </div>
                <div class="col-xs-12 col-md-8">
                    Account Name:
                    <input class="form-control" type="text" v-model="newLabel.label" />
                    Account User Id:
                    <input class="form-control" type="text" v-model="newLabel.text0" />
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import jsonRender from './jsonRender.vue';
    import jsonData from './jsonData.vue';
    import jsonDataValidator from './jsonDataValidator.vue';
    import jsonDataSlide from './jsonDataSlide.vue';
    import jsonDataLayout from './jsonDataLayout.vue';
    import jsonDataLaws from './jsonDataLaws.vue';
    import jsonDataLanding from './jsonDataLanding.vue';
    import imageList from './imageList.vue';
    import modalX from '../components/base/ModalX1.vue';
    import apis from '../api/extApi.js';

    export default {
        components: {
            imageList: imageList,
            modalX: modalX,
            jsonRender: jsonRender,
            jsonData: jsonData,
            jsonDataValidator: jsonDataValidator,
            jsonDataSlide: jsonDataSlide,
            jsonDataLayout: jsonDataLayout,
            jsonDataLaws: jsonDataLaws,
            jsonDataLanding: jsonDataLanding
        },
        props: ["newLabel", "labelType", "shopInfo"],
        data: function () {
            return {
                apiClient: apis.api,
                uiClient: null,
                imgHandler: null,
                isSelectingImage: false,
                selectedImgs: [],
                isEditJson: false,
                isEditValidateJson: false,
                initJsonData: null,
                jsonHandler: null,
                isEditSlideJson: false,
                isEditLayoutJson: false,
                isEditLawsJson: false,
                isEditLandingJson: false
            };
        },
        methods: {
            onImgSelect: function (imgFile) {
                this.selectedImgs.push(imgFile);
                this.imgHandler(imgFile, this.selectedImgs);
            },
            setNewLabelImg: function (newImg) {
                this.newLabel.frnImgPath = newImg.thumbPath;
                this.newLabel.label = newImg.fileName + newImg.fileType;
                this.isSelectingImage = false;
            },
            selectImg: function (handler) {
                this.imgHandler = handler;
                this.isSelectingImage = !this.isSelectingImage;
            },
            onJsonReturn: function (ret) {
                this.isEditJson = false;
                console.log('ret onJsonReturn', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onJsonDataValidatorReturn: function (ret) {
                this.isEditValidateJson = false;
                console.log('ret onJsonReturn', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onSlideJsonReturn: function (ret) {
                this.isEditSlideJson = false;
                console.log('ret', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onLayoutJsonReturn: function (ret) {
                this.isEditLayoutJson = false;
                console.log('ret', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onLawsJsonReturn: function (ret) {
                this.isEditLawsJson = false;
                console.log('ret', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            },
            onLandingJsonReturn: function (ret) {
                this.isEditLandingJson = false;
                console.log('ret', ret);
                if (this.jsonHandler !== null) this.jsonHandler(ret);
                this.$emit('onUpdateConfirm', this.newLabel);
            }
        },
        created: function () {

        },
        mounted: function () {
            console.log("labelEntryTpl mounted", this.labelType, this.newLabel);
            this.uiClient = apis.ui.getShopClient({ userId: this.shopInfo.shopUserId });
        },
        destroyed: function () {
            this.uiClient.destroy();
            console.log("labelEntryTpl destroyed", this.labelType, this.newLabel);
        }
    }
</script>